import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import ToyDetailsContent from '../components/ToyDetailsContent';

const ViewToy = (props) => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const { match: { params: { id } = {} } = {} } = props;

  const history = useHistory();
  const [toyDetail, setToyDetail] = useState({});

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton customLink={`${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}`} />
        <div className="portal-header">View Toy</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_TOY,
          PERMISSION_TYPE?.UPDATE,
          permissions,
        ) && (
          <div className="header-btn-wrapper">
            <Button
              className="common-button mr-16"
              size="middle"
              onClick={() =>
                history?.push(
                  `${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}/edit/${id}`,
                )
              }
              disabled={toyDetail?.isArchived}
            >
              Edit Toy
            </Button>
          </div>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_TOY,
          PERMISSION_TYPE?.UPDATE,
          permissions,
        ) && (
          <div className="header-btn-wrapper">
            <Button
              className="common-button mr-16"
              size="middle"
              onClick={() =>
                history?.push(
                  `${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}/edit/${id}`,
                )
              }
              disabled={toyDetail?.isArchived}
            >
              Edit Toy
            </Button>
          </div>
        )}
      </Portal>
      <Card className="full-height-with-nav" title="Toy Details">
        <ToyDetailsContent toyId={id} onToyLoaded={setToyDetail} />
      </Card>
    </>
  );
};

export default ViewToy;
